import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/pages/area-privada/components/base/base.component';

@Component({
  selector: 'dum-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends BaseComponent implements OnInit {

  constructor() {
    super();
   }

  ngOnInit(): void {
  }

}
